
import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("ZonaExtendida");
const crud = rpcCrudService<models.ZonaExtendida, models.ZonaExtendida>(controller);

export const ZonaExtendida = cacheResource({
    ...crud,
    /**Obtiene todas las entidades filtradas por la zona */
    query: async (filtro: models.FiltroZonaExtendida): Promise<models.ZonaExtendidaDto[]> => await controller('Query', {}, filtro),

    querySinFiltro: async (): Promise<models.ZonaExtendidaDto[]> => await controller('QuerySinFiltro', {},),

}, {
        query: true,
        getMemo: true,
    }, {
        add: true,
        delete: true,
        update: true
    });



// WEBPACK FOOTER //
// ./app/resources/items/zonaextendida.tsx